import type { AssetTypeEntity } from "@/entities/asset-type";
import type { ReferentialAssetTypeCategorie } from "@/entities/referential/referential-asset-type-categories";

export const getAssetTypeCategory = (
  assetType?: AssetTypeEntity,
  categories?: ReferentialAssetTypeCategorie[]
) => {
  const categorySlug = assetType?.asset_type_category;

  if (!categorySlug) return undefined;

  const category = categories?.find(
    (category) => category.slug === categorySlug
  );

  return category;
};
